/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const FileDto = zod.object({
  "id": zod.string().uuid().optional(),
  "blobId": zod.string().optional(),
  "fileName": zod.string().optional(),
  "fileType": zod.string().optional(),
  "fileSize": zod.number().optional(),
  "path": zod.string().optional(),
  "url": zod.string().optional(),
  "isDeleted": zod.boolean().optional(),
  "fileFieldTypeId": zod.number().optional(),
  "isSignedDocument": zod.boolean().optional()
});

export type FileDto = zod.input<typeof FileDto>;
export type FileDtoOutput = zod.output<typeof FileDto>;
